import { configuration } from '../config/Config';
import moment from "moment";
import jwt from 'jwt-simple';

const TOKEN_KEY = configuration.TOKEN_KEY;
const SECRET_KEY = configuration.SECRET_KEY;
const PROFILE_KEY = configuration.PROFILE_KEY;
const profile = (localStorage.getItem(PROFILE_KEY)) ? jwt.decode(localStorage.getItem(PROFILE_KEY), SECRET_KEY, false, 'HS256') : {};
const URL_SERVICE = configuration.CONFIGURATION_URL_SERVICE;

export const api = {
    identity: {
        apptxnid: "123",
        reqtxnid: "ea9e5895-29c9-4f98-97ef-fcb4ba96e56c",
        reqdate: moment().format("YYYY-MM-DD HH:mm:ss"),
        appid: "alms-1",
        userid: profile.username,
        signature: localStorage.getItem(TOKEN_KEY),
        seqno: "1"
    },
    url: {
        wso: {
            login: `${URL_SERVICE}/api/login/v1.0/login`
        },
        user: {
            sessionmanagement: {
                login               : URL_SERVICE+"/amala/user/v1.2/session/login",
                expire              : URL_SERVICE+"/amala/user/v1.2/session/expire",
                authenticate        : URL_SERVICE+"/amala/user/v1.2/sessionintegration/authenticate",
                extend              : URL_SERVICE+"/amala/user/v1.2/sessionintegration/extend",
                check               : URL_SERVICE+"/amala/user/v1.2/session/check"
            },
            user: {
                list                : URL_SERVICE+"/amala/user/v1.2/user/retrieve",
                resetpassword       : URL_SERVICE+"/amala/user/v1.2/user/resetpassword",
                changepassword      : URL_SERVICE+"/amala/user/v1.2/user/changepassword",
                resetvalidation     : URL_SERVICE+"/amala/user/v1.2/user/resetvalidation",
                resetuserpassword   : URL_SERVICE+"/amala/user/v1.2/user/resetuserpassword"
            },
            role: {                
                retrieveroledetail  : `${URL_SERVICE}/amala/user/v1.2/role/retrieveroledetail`
            }
        },
        masterdata: {
            airline: {
                retrieve    : `${URL_SERVICE}/amala/partner/v1.2/airline/retrieve`
            },
            activitycode: {
                retrieve    : `${URL_SERVICE}/amala/accrual/catalog/v1.2/activitycode/retrieve`
            },
            customtransaction : {
                retrieve    : `${URL_SERVICE}/amala/accrual/catalog/v1.2/customtransaction/retrieve`
            },
            tier: {
                retrieve    : `${URL_SERVICE}/amala/tier/v1.2/tier/retrieve`
            },
            tierrank: {
                retrieve    : `${URL_SERVICE}/amala/tier/v1.2/tierrank/retrieve`
            },
            membership: {
                retrieve    : `${URL_SERVICE}/amala/tier/v1.2/membership/retrieve`
            },
            country: {
                retrieve    : `${URL_SERVICE}/amala/master/location/v1.2/country/retrieve`
            },
            region: {
                retrieve    : `${URL_SERVICE}/amala/master/location/v1.2/region/retrieve`
            },
            airport: {
                retrieve     : `${URL_SERVICE}/amala/master/location/v1.2/airport/retrieve`
            },
            earningmiles: {
                list         : `${URL_SERVICE}/amala/partner/v1.2/earningmiles/retrieve`,
                create       : `${URL_SERVICE}/amala/partner/v1.2/earningmiles/create`,
                update       : `${URL_SERVICE}/amala/partner/v1.2/earningmiles/update`,
                delete       : `${URL_SERVICE}/amala/partner/v1.2/earningmiles/delete`,
                activate     : `${URL_SERVICE}/amala/partner/v1.2/earningmiles/activate`,
                deactivate   : `${URL_SERVICE}/amala/partner/v1.2/earningmiles/deactivate`
            },
            distancerange: {
                retrieve     : `${URL_SERVICE}/amala/award/config/v1.2/distancerange/retrieve`,
                create       : `${URL_SERVICE}/amala/award/config/v1.2/distancerange/create`,
                update       : `${URL_SERVICE}/amala/award/config/v1.2/distancerange/update`,
                delete       : `${URL_SERVICE}/amala/award/config/v1.2/distancerange/delete`,
                activate     : `${URL_SERVICE}/amala/award/config/v1.2/distancerange/activate`,
                deactivate   : `${URL_SERVICE}/amala/award/config/v1.2/distancerange/deactivate`
            },
            accrualruleod: {
                getcitypairbydistancerange  : URL_SERVICE+"/amala/accrual/rule/v1.2/origindestination/getcitypairbydistancerange",
                retrieve    : `${URL_SERVICE}/amala/master/location/v1.2/airport/retrieve`
            },
            city: { 
                retrieve    : `${URL_SERVICE}/amala/master/location/v1.2/city/retrieve`
            },
            state: {
                retrieve    : `${URL_SERVICE}/amala/master/location/v1.2/state/retrieve`
            },
            generalconfig: {
                retrieve    : `${URL_SERVICE}/amala/master/general/v1.2/generalconfig/retrieve`
            },
        },
        partnervoucher: {
            partner: {
                create              : `${URL_SERVICE}/amala/partner/v1.2/partner/create`,
                retrieve            : `${URL_SERVICE}/amala/partner/v1.2/partner/retrieve`,
                retrievedetail      : `${URL_SERVICE}/amala/partner/v1.2/partner/retrievedetail`,
                update              : `${URL_SERVICE}/amala/partner/v1.2/partner/update`,
                delete              : `${URL_SERVICE}/amala/partner/v1.2/partner/delete`,
                getall              : `${URL_SERVICE}/amala/partner/v1.2/partner/getpartner`,
                activate            : `${URL_SERVICE}/amala/partner/v1.2/partner/activate`,
                deactivate          : `${URL_SERVICE}/amala/partner/v1.2/partner/deactivate`,
            },
            partnerbulk: {
                create              : `${URL_SERVICE}/amala/partner/v1.2/partnerbulk/create`,
                retrievedetail      : `${URL_SERVICE}/amala/partner/v1.2/partnerbulk/retrievedetail`,
                update              : `${URL_SERVICE}/amala/partner/v1.2/partnerbulk/update`,
                delete              : `${URL_SERVICE}/amala/partner/v1.2/partnerbulk/delete`,
                pdf                 : URL_SERVICE + "/amala/partner/v1.2/partnerbulk/downloadPdf",
                csv                 : URL_SERVICE + "/amala/partner/v1.2/partnerbulk/downloadCsv"
            },
            partnertransaction: {
                retrieve    : URL_SERVICE + "/amala/partner/v1.2/partnertransaction/retrieve",
                create      : URL_SERVICE + "/amala/partner/v1.2/partnertransaction/create",
                update      : URL_SERVICE + "/amala/partner/v1.2/partnertransaction/update",
                delete      : URL_SERVICE + "/amala/partner/v1.2/partnertransaction/delete",
                pdf         : URL_SERVICE + "/amala/partner/v1.2/partnertransaction/downloadPdf",
                csv         : URL_SERVICE + "/amala/partner/v1.2/partnertransaction/downloadCsv"
            },
            partnerbilling: {
                retrieve    : URL_SERVICE + "/amala/partner/v1.2/partnerbilling/retrieve",
                create      : URL_SERVICE + "/amala/partner/v1.2/partnerbilling/create",
                update      : URL_SERVICE + "/amala/partner/v1.2/partnerbilling/update",
                delete      : URL_SERVICE + "/amala/partner/v1.2/partnerbilling/delete",
                detail      : URL_SERVICE + "/amala/partner/v1.2/partnerbilling/retrievedetail",
                pdf         : URL_SERVICE + "/amala/partner/v1.2/partnerbilling/downloadPdf",
                csv         : URL_SERVICE + "/amala/partner/v1.2/partnerbilling/downloadCsv"
            },
            partnercobrand: {
                create              : `${URL_SERVICE}/amala/partner/v1.2/cobrand/create`,
                retrieve            : `${URL_SERVICE}/amala/partner/v1.2/cobrand/retrieve`,
                retrievedetail      : `${URL_SERVICE}/amala/partner/v1.2/cobrand/retrievedetail`,
                update              : `${URL_SERVICE}/amala/partner/v1.2/cobrand/update`,
                delete              : `${URL_SERVICE}/amala/partner/v1.2/cobrand/delete`,
                activate            : `${URL_SERVICE}/amala/partner/v1.2/cobrand/activate`,
                deactivate          : `${URL_SERVICE}/amala/partner/v1.2/cobrand/deactivate`
            },
            cobrandbonus: {
                create              : `${URL_SERVICE}/amala/partner/v1.2/cobrandbonus/create`,
                retrieve            : `${URL_SERVICE}/amala/partner/v1.2/cobrandbonus/retrieve`,
                retrievedetail      : `${URL_SERVICE}/amala/partner/v1.2/cobrandbonus/retrievedetail`,
                update              : `${URL_SERVICE}/amala/partner/v1.2/cobrandbonus/update`,
                delete              : `${URL_SERVICE}/amala/partner/v1.2/cobrandbonus/delete`,
                activate            : `${URL_SERVICE}/amala/partner/v1.2/cobrandbonus/activate`,
                deactivate          : `${URL_SERVICE}/amala/partner/v1.2/cobrandbonus/deactivate`
            },
            enrollmentrule: {
                create	            : `${URL_SERVICE}/amala/partner/enrollmentfile/v1.2/rule/create`,
                update	            : `${URL_SERVICE}/amala/partner/enrollmentfile/v1.2/rule/update`,
                retrieve	        : `${URL_SERVICE}/amala/partner/enrollmentfile/v1.2/rule/retrieve`
            },
            partnerlocation: {
                create              : `${URL_SERVICE}/amala/partner/v1.2/partnerlocation/create`,
                retrieve            : `${URL_SERVICE}/amala/partner/v1.2/partnerlocation/retrieve`,
                retrievedetail      : `${URL_SERVICE}/amala/partner/v1.2/partnerlocation/retrievedetail`,
                update              : `${URL_SERVICE}/amala/partner/v1.2/partnerlocation/update`,
                delete              : `${URL_SERVICE}/amala/partner/v1.2/partnerlocation/delete`,
                getall              : `${URL_SERVICE}/amala/partner/v1.2/partnerlocation/getpartnerlocation`
            },
            partnerbulkdetail: {
                retrievedetail      : `${URL_SERVICE}/amala/partner/v1.2/partnerbulkdetail/retrievedetail`
            },
            memberactivity:{
                retrievedetail      : `${URL_SERVICE}/amala/member/activity/v1.2/activity/retrievedetail` 
            },    
            method: {
                retrieve            : `${URL_SERVICE}/amalavoucher/voucher/v1.0/partnervoucher/retrieve`
            }
        },
        partnergroup : {
            create          : URL_SERVICE+"/amala/partner/v1.2/partnergroup/create",
            list            : URL_SERVICE+"/amala/partner/v1.2/partnergroup/retrieve",
            detail          : URL_SERVICE+"/amala/partner/v1.2/partnergroup/retrievedetail",
            update          : URL_SERVICE+"/amala/partner/v1.2/partnergroup/update",
            delete          : URL_SERVICE+"/amala/partner/v1.2/partnergroup/delete",
            addpartner      : URL_SERVICE+"/amala/partner/v1.2/partnergroup/addpartner",
            removepartner   : URL_SERVICE+"/amala/partner/v1.2/partnergroup/removepartner"
        },
        redeemption: {
            certificate: {
                retrieve            : `${URL_SERVICE}/amala/redemption/certificate/v1.2/retrieve`,
                retrievedetail      : `${URL_SERVICE}/amala/redemption/certificate/v1.2/retrievedetail`,
                voucherverification : `${URL_SERVICE}/amala/redemption/certificate/v1.2/voucherverification`,
                updatestatus        : `${URL_SERVICE}/amala/redemption/certificate/v1.2/updatestatus`,
            },
            blackout: {
                retrieve            : `${URL_SERVICE}/amala/award/period/v1.2/blackout/retrieve`,
                create              : `${URL_SERVICE}/amala/award/period/v1.2/blackout/create`,
                update              : `${URL_SERVICE}/amala/award/period/v1.2/blackout/update`,
                delete              : `${URL_SERVICE}/amala/award/period/v1.2/blackout/delete`,
                activate            : `${URL_SERVICE}/amala/award/period/v1.2/blackout/activate`,
                deactivate          : `${URL_SERVICE}/amala/award/period/v1.2/blackout/deactivate`,
            }
        },
        awardtype: {
            create       : URL_SERVICE+"/amala/award/config/v1.2/type/create",
            list         : URL_SERVICE+"/amala/award/config/v1.2/type/retrieveawardtype",
            update       : URL_SERVICE+"/amala/award/config/v1.2/type/update",
            delete       : URL_SERVICE+"/amala/award/config/v1.2/type/delete",
            categorytype : URL_SERVICE+"/amala/award/config/v1.2/type/retrievecategorytype",
            category     : URL_SERVICE+"/amala/award/config/v1.2/type/retrievecategory"
        },
        peakseason: {
            create      : URL_SERVICE+"/amala/award/period/v1.2/peakseason/create",
            list        : URL_SERVICE+"/amala/award/period/v1.2/peakseason/retrieve",
            detail      : URL_SERVICE+"/amala/award/period/v1.2/peakseason/retrievedetail",
            update      : URL_SERVICE+"/amala/award/period/v1.2/peakseason/update",
            delete      : URL_SERVICE+"/amala/award/period/v1.2/peakseason/delete",
            activate    : URL_SERVICE+"/amala/award/period/v1.2/peakseason/activate",
            deactivate  : URL_SERVICE+"/amala/award/period/v1.2/peakseason/deactivate"
        },
        awardmaster: {
            create              : URL_SERVICE+"/amala/award/config/v1.2/master/create",
            list                : URL_SERVICE+"/amala/award/config/v1.2/master/retrieve",
            detailbasicinfo     : URL_SERVICE+"/amala/award/config/v1.2/master/retrievedetailbasicinfo",
            update              : URL_SERVICE+"/amala/award/config/v1.2/master/updatebasicinfo",
            detailpartner       : URL_SERVICE+"/amala/award/config/v1.2/master/retrievedetailpartner",
            updatepartner       : URL_SERVICE+"/amala/award/config/v1.2/master/updatepartner",
            detailcancelupdate  : URL_SERVICE+"/amala/award/config/v1.2/master/retrievecancelupdaterule",
            updatecancelupdate  : URL_SERVICE+"/amala/award/config/v1.2/master/updatecancelupdaterule",
            detailcertificate   : URL_SERVICE+"/amala/award/config/v1.2/master/retrievecertificate",
            updatecertificate   : URL_SERVICE+"/amala/award/config/v1.2/master/updatecertificate",
            detailstatus        : URL_SERVICE+"/amala/award/config/v1.2/master/retrievedetailstatus",
            activatestatus      : URL_SERVICE+"/amala/award/config/v1.2/master/activation",
            terminatestatus     : URL_SERVICE+"/amala/award/config/v1.2/master/terminate",
            detailfixedprice    : URL_SERVICE+"/amala/award/config/v1.2/master/retrievefixedprice",
            updatefixedprice    : URL_SERVICE+"/amala/award/config/v1.2/master/updatefixedprice",
            retrievecancelupdate: URL_SERVICE+"/amala/award/config/v1.2/master/retrievecancelupdaterule"
        },
        channel: {
            list            : URL_SERVICE+"/amala/master/general/v1.2/channel/retrieve",
            application : {
                list        : URL_SERVICE+"/amala/master/general/v1.2/channel/application/retrieve",
            }
        },
        statement : {
            create      : URL_SERVICE+"/amala/master/statement/v1.2/statement/create",
            list        : URL_SERVICE+"/amala/master/statement/v1.2/statement/retrieve",
            detail      : URL_SERVICE+"/amala/master/statement/v1.2/statement/retrievedetail",
            update      : URL_SERVICE+"/amala/master/statement/v1.2/statement/update",
            delete      : URL_SERVICE+"/amala/master/statement/v1.2/statement/delete",
            activate    : URL_SERVICE+"/amala/master/statement/v1.2/statement/activate",
            deactivate  : URL_SERVICE+"/amala/master/statement/v1.2/statement/deactivate"
        },
        partnerlocation : {
            create  : URL_SERVICE+"/amala/partner/v1.2/partnerlocation/create",
            list    : URL_SERVICE+"/amala/partner/v1.2/partnerlocation/retrieve",
            detail  : URL_SERVICE+"/amala/partner/v1.2/partnerlocation/retrievedetail",
            update  : URL_SERVICE+"/amala/partner/v1.2/partnerlocation/update",
            delete  : URL_SERVICE+"/amala/partner/v1.2/partnerlocation/delete",
            getall  : URL_SERVICE+"/amala/partner/v1.2/partnerlocation/getpartnerlocation"
        },
        branch : {
            create      : URL_SERVICE+"/amala/branch/v1.2/branch/create",
            list        : URL_SERVICE+"/amala/branch/v1.2/branch/retrieve",
            detail      : URL_SERVICE+"/amala/branch/v1.2/branch/retrievedetail",
            update      : URL_SERVICE+"/amala/branch/v1.2/branch/update",
            delete      : URL_SERVICE+"/amala/branch/v1.2/branch/delete",
            activate    : URL_SERVICE+"/amala/branch/v1.2/branch/activate",
            deactivate  : URL_SERVICE+"/amala/branch/v1.2/branch/deactivate"
        },
        awardeligiblebranch: {
            list    : URL_SERVICE+"/amala/award/config/v1.2/eligiblebranch/retrieve",
            update  : URL_SERVICE+"/amala/award/config/v1.2/eligiblebranch/update"
        },
        tier: {
            create : URL_SERVICE+"/amala/tier/v1.2/tier/create",
            list   : URL_SERVICE+"/amala/tier/v1.2/tier/retrieve",
            detail : URL_SERVICE+"/amala/tier/v1.2/tier/retrievedetail",
            update : URL_SERVICE+"/amala/tier/v1.2/tier/update",
            delete : URL_SERVICE+"/amala/tier/v1.2/tier/delete"
        },
        awardeligibletiers: {
            list    : URL_SERVICE+"/amala/award/config/v1.2/eligibletiers/retrieve",
            update  : URL_SERVICE+"/amala/award/config/v1.2/eligibletiers/update"
        },
        awardvouchertext: {
            create      : URL_SERVICE+"/amala/award/config/v1.2/voucher/create",
            list        : URL_SERVICE+"/amala/award/config/v1.2/voucher/retrieve",
            detail      : URL_SERVICE+"/amala/award/config/v1.2/voucher/retrievedetail",
            update      : URL_SERVICE+"/amala/award/config/v1.2/voucher/update",
            delete      : URL_SERVICE+"/amala/award/config/v1.2/voucher/delete",
            activate    : URL_SERVICE+"/amala/award/config/v1.2/voucher/activate",
            deactivate  : URL_SERVICE+"/amala/award/config/v1.2/voucher/deactivate"
        },
        language : {
            create      : URL_SERVICE+"/amala/master/general/v1.2/language/create",
            list        : URL_SERVICE+"/amala/master/general/v1.2/language/retrieve",
            detail      : URL_SERVICE+"/amala/master/general/v1.2/language/retrievedetail",
            update      : URL_SERVICE+"/amala/master/general/v1.2/language/update",
            delete      : URL_SERVICE+"/amala/master/general/v1.2/language/delete",
            activate    : URL_SERVICE+"/amala/master/general/v1.2/language/activate",
            deactivate  : URL_SERVICE+"/amala/master/general/v1.2/language/deactivate"
        },
        file: {
            retrieve    : URL_SERVICE+"/amalapartner/filemanagement/v1.0/file/retrieve",
            detail      : URL_SERVICE+"/amalapartner/filemanagement/v1.0/file/retrievedetail",
            download    : URL_SERVICE+"/amalapartner/filemanagement/v1.0/file/downloadfile",
            summary     : URL_SERVICE+"/amalapartner/filemanagement/v1.0/file/downloadsummary",
            uploadfile  : URL_SERVICE+"/amalapartner/filemanagement/v1.0/file/uploadfile"
        },
        fileamala: {
            retrieve    : URL_SERVICE+"/amala/filemanagement/v1.2/file/retrieve",
            detail      : URL_SERVICE+"/amala/filemanagement/v1.2/filedata/retrieve",
            create      : URL_SERVICE+"/amala/filemanagement/v1.2/file/create",
            update      : URL_SERVICE+"/amala/filemanagement/v1.2/file/update",
            delete      : URL_SERVICE+"/amala/filemanagement/v1.2/file/delete",
            uploadfile  : URL_SERVICE+"/amala/filemanagement/v1.0/file/uploadfile",
            downloadfile    : URL_SERVICE+"/amala/filemanagement/v1.2/file/downloadfile",
            downloadsum     : URL_SERVICE+"/amala/filemanagement/v1.2/file/downloadsummary"
        },
        filedataamala: {
            enrollment      : URL_SERVICE+"/amala/filemanagement/v1.2/filedataenrollment/retrieve",
            transferpoint   : URL_SERVICE+"/amala/filemanagement/v1.2/filedatatransferpoint/retrieve",
            terminate       : URL_SERVICE+"/amala/filemanagement/v1.2/filedatatermination/retrieve",
            approvalcobrand : URL_SERVICE+"/amala/filemanagement/v1.2/filedataapprovalcobrand/retrieve",
            cobrandfasstrack: URL_SERVICE+"/amala/filemanagement/v1.2/fasttrack/retrieve"
        },
        voucherlist: {
            create      : `${URL_SERVICE}/amalapartner/partner/v1.0/voucher/create`,
            update      : `${URL_SERVICE}/amalapartner/partner/v1.0/voucher/update`,
            retrieve    : `${URL_SERVICE}/amalapartner/partner/v1.0/voucher/retrieve`,
            delete      : `${URL_SERVICE}/amalapartner/partner/v1.0/voucher/delete`,
            viewhistory : `${URL_SERVICE}/amalapartner/partner/v1.0/voucher/viewhistory`,
            uploadfile  : `${URL_SERVICE}/amalapartner/partner/v1.0/voucher/uploadfile`,
            download    : `${URL_SERVICE}/amalapartner/partner/v1.0/voucher/downloadfile`
        },
        printing: {
            list    : URL_SERVICE + "/amala/mailing/order/integration/printing/v1.2/integration/retrieve",
            create  : URL_SERVICE + "/amala/mailing/order/integration/v1.2/printed/create",
            update  : URL_SERVICE + "/amala/mailing/order/integration/printing/v1.2/integration/update",
            bulk    : URL_SERVICE + "/amala/mailing/order/integration/printing/v1.2/integration/updatebulk",
            detail  : URL_SERVICE + "/amala/mailing/order/integration/printing/v1.2/printed/retrievedetail",
            upload  : URL_SERVICE + "/amala/mailing/order/integration/printing/v1.2/integration/upload",
            download: URL_SERVICE + "/amala/mailing/order/integration/printing/v1.2/integration/download"
        },
        delivery: {
            list      : URL_SERVICE + "/amala/mailing/order/integration/delivered/v1.2/integration/retrieve",
            create    : URL_SERVICE + "/amala/mailing/order/integration/v1.2/delivered/create",
            bulk      : URL_SERVICE + "/amala/mailing/order/integration/delivered/v1.2/integration/update/bulk",
            update    : URL_SERVICE + "/amala/mailing/order/integration/delivered/v1.2/integration/update",
            detail    : URL_SERVICE + "/amala/mailing/order/integration/delivered/v1.2/retrievedetail",
            download  : URL_SERVICE + "/amala/mailing/order/integration/delivered/v1.2/integration/download",
            upload    : URL_SERVICE + "/amala/mailing/order/integration/delivered/v1.2/integration/upload",
        },
        packaging: {
            list      : URL_SERVICE + "/amala/mailing/order/integration/packaging/v1.2/integration/retrieve",
            create    : URL_SERVICE + "/amala/mailing/order/integration/v1.2/packed/create",
            update    : URL_SERVICE + "/amala/mailing/order/integration/packaging/v1.2/integration/update",
            detail    : URL_SERVICE + "/amala/mailing/order/integration/packaging/v1.2/packed/retrievedetail",
            bulk      : URL_SERVICE + "/amala/mailing/order/integration/packaging/v1.2/integration/updatebulk",
            upload    : URL_SERVICE + "/amala/mailing/order/integration/packaging/v1.2/integration/upload",
            download  : URL_SERVICE + "/amala/mailing/order/integration/packaging/v1.2/integration/download",
        },
        reorder:  {
            list    : URL_SERVICE + "/amala/mailing/order/integration/v1.2/reorder/retrieve",
            detail  : URL_SERVICE + "/amala/mailing/order/integration/v1.2/reorder/retrievedetail",
            create  : URL_SERVICE + "/amala/mailing/order/integration/v1.2/reorder/create",
            update  : URL_SERVICE + "/amala/mailing/order/integration/v1.2/reorder/update",
        },
        return:   {    
            list    : URL_SERVICE + "/amala/mailing/order/v1.2/orderreturn/retrieve",
            detail  : URL_SERVICE + "/amala/mailing/order/v1.2/orderreturn/retrievedetail",
            create  : URL_SERVICE + "/amala/mailing/order/v1.2/orderreturn/create",
            update  : URL_SERVICE + "/amala/mailing/order/v1.2/integration/update",
        },
        letter: {
            retrieve           : URL_SERVICE+"/amala/mailing/product/letter/v1.2/master/retrieve",
        },
        mailingproduct: {
            list                : URL_SERVICE+"/amala/mailing/product/catalogue/v1.2/master/retrieve",
            getcatalog          : URL_SERVICE+"/amala/mailing/product/catalogue/integration/v1.2/getcatalog",
        },
        inventorysys: {
            detail          : URL_SERVICE+"/amala/mailing/product/inventory/integration/v1.2/retrievedetail",
        },
        worknotes: {
            update: URL_SERVICE + "/amala/mailing/order/integration/v1.2/worknote/update",
            detail: URL_SERVICE + "/amala/mailing/order/integration/v1.2/worknote/retrieve"
        },
        ticketoffice: {
            list: URL_SERVICE + "/amala/branch/v1.2/ticketoffice/retrieve",
        },
        member: {
            list                    : URL_SERVICE + "/amalapartner/member/profile/v1.2/profile",
        },
        memberlock: {
            main                    : URL_SERVICE + "/amala/member/profile/v1.2/memberlock/",
            create                  : URL_SERVICE + "/amala/member/profile/v1.2/memberlock/create",
            update                  : URL_SERVICE + "/amala/member/profile/v1.2/memberlock/update",
            list                    : URL_SERVICE + "/amala/member/profile/v1.2/memberlock/retrieve",
        },
        memberidentity: {
            retrieve                : URL_SERVICE + "/amala/member/profile/v1.2/memberidentity/memberretrieve",
            list                    : URL_SERVICE + "/amala/member/profile/v1.2/memberidentity/retrieve",
            create                  : URL_SERVICE + "/amala/member/profile/v1.2/memberidentity/create",
            update                  : URL_SERVICE + "/amala/member/profile/v1.2/memberidentity/update",
            delete                  : URL_SERVICE + "/amala/member/profile/v1.2/memberidentity/delete",
            verify                  : URL_SERVICE + "/amala/member/profile/v1.2/memberidentity/verifyidentity",
            reject                  : URL_SERVICE + "/amala/member/profile/v1.2/memberidentity/rejectidentity"
        },
        mileagecriteria: {
            create                  : URL_SERVICE + "/amala/tier/v1.2/mileagecriteria/create",
            list                    : URL_SERVICE + "/amala/tier/v1.2/mileagecriteria/retrieve",
            detail                  : URL_SERVICE + "/amala/tier/v1.2/mileagecriteria/retrievedetail",
            update                  : URL_SERVICE + "/amala/tier/v1.2/mileagecriteria/update",
            delete                  : URL_SERVICE + "/amala/tier/v1.2/mileagecriteria/delete"
        },
        membertransaction: {
            transfer                : URL_SERVICE + "/amala/member/transaction/transfer/v1.2/transfer",
            list                    : URL_SERVICE + "/amalapartner/member/transaction/v1.2/transaction/retrieve",
            detail                  : URL_SERVICE + "/amala/member/transaction/v1.2/transaction/retrievedetail",
            create                  : URL_SERVICE + "/lms/member/transaction/create/v1",
            earningcorrection       : URL_SERVICE + "/amala/accrual/transaction/earningcorrection/v1.2/earningcorrection",
            mileagelog              : URL_SERVICE + "/amala/member/transfermileagelog/v1.2/retrieve",
            count                   : URL_SERVICE+"/amala/member/transaction/v1.2/transaction/count",
            csv                     : URL_SERVICE+"/amala/member/transaction/v1.2/transaction/downloadfile",
            pdf                     : URL_SERVICE+"/amala/member/transaction/v1.2/transaction/downloadfilePDF",
            generatepdf             : URL_SERVICE+"/amala/member/transaction/v1.2/transaction/generatefilePDF",
            generatecsv             : URL_SERVICE+"/amala/member/transaction/v1.2/transaction/generatefile"
        },
        memberactivity:{
            list                    : URL_SERVICE+"/amala/member/activity/v1.2/activity/retrieve",
            detail                  : URL_SERVICE+"/amala/member/activity/v1.2/activity/retrievedetail",
            getinvalidnamechecklist : URL_SERVICE+"/amala/member/activity/v4.0/getinvalidnamechecklist",
            limit                   : URL_SERVICE+"/amala/member/activity/limit/v1.2/retrieve"
        },
        tierrank: {
            create                  : URL_SERVICE + "/amala/tier/v1.2/tierrank/create",
            list                    : URL_SERVICE + "/amala/tier/v1.2/tierrank/retrieve"
        },
        accrualrulenonair: {
            create: URL_SERVICE + "/amala/accrual/rule/v1.2/nonair/create",
            list: URL_SERVICE + "/amala/accrual/rule/v1.2/nonair/retrieve",
            update: URL_SERVICE + "/amala/accrual/rule/v1.2/nonair/update",
            delete: URL_SERVICE + "/amala/accrual/rule/v1.2/nonair/delete"
        },
        membernonairactivity: {
            create              : URL_SERVICE+"/amala/member/activity/nonair/validate/v4.0/create",
            detail              : URL_SERVICE+"/amala/member/activity/v4.0/retrievedetail",
            update              : URL_SERVICE+"/amala/member/activity/v1.2/nonairactivity/update",
            delete              : URL_SERVICE+"/amala/member/activity/v1.2/nonairactivity/delete",
            createwithrating    : URL_SERVICE+"/amala/member/activity/v1.2/nonairactivity/rating/create",
            updatewithrating    : URL_SERVICE+"/amala/member/activity/v1.2/nonairactivity/rating/update",
            cancelwithrating    : URL_SERVICE+"/amala/member/activity/v1.2/nonairactivity/rating/cancel",
            geteligible         : URL_SERVICE+"/amala/member/activity/v1.2/nonairactivity/geteligibletrx"
        },
        dashboard: {
            detail  : URL_SERVICE+"/amala/partner/v1.2/dashboard/retrievedetail"
        }
    }
}